// تهيئة الغلاف الأصلي (Capacitor): شريط الحالة، شاشة البداية، وزر الرجوع في أندرويد.
import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();

export const initNative = async () => {
  if (!isNative()) return;
  document.documentElement.classList.add("native-app");
  // أمان: شاشة البداية تُخفى قسراً بعد 5 ثوانٍ حتى لو فشل أي شيء بعدها (آبل 2.1: لا تجمّد).
  const safety = setTimeout(async () => {
    try {
      const { SplashScreen } = await import("@capacitor/splash-screen");
      await SplashScreen.hide();
    } catch {}
  }, 5000);
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    // يمتدّ الويب‑فيو تحت شريط الحالة حتى لا يظهر شريط ثابت اللون أعلى الشاشة،
    // والحشو يتولّاه env(safe-area-inset-top) في CSS فيطابق لون الواجهة دائماً.
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Default });
  } catch {}
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
    clearTimeout(safety);
  } catch {}
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else App.exitApp();
    });
    // إصلاح TestFlight: عند عودة التطبيق للواجهة، أعِد قراءة مفاتيح الميزات فوراً.
    App.addListener("appStateChange", ({ isActive }) => {
      if (isActive) window.dispatchEvent(new CustomEvent("features:refresh"));
    });
  } catch {}
  try {
    const { Keyboard, KeyboardResize } = await import("@capacitor/keyboard");
    await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
  } catch {}
};
